/* eslint-disable */
import React, { Component } from 'react'


import Svg,{
  Circle,
  Ellipse,
  G,
  LinearGradient,
  RadialGradient,
  Line,
  Path,
  Polygon,
  Polyline,
  Rect,
  Symbol,
 
  Use,
  Defs,
  Stop
} from 'react-native-svg';

export const SvgPush = ({size}) => {
    return (  <Svg
       
        height = {size}
        width = {size}
        viewBox="0 0 492.24 600.02">
        <G id="Layer_2" data-name="Layer 2">
        <G id="Layer_1-2" data-name="Layer 1">
        <Path fill = "#4a536e" class="cls-1" d="M253,0c2.68.81,5.38,1.54,8,2.44a45.76,45.76,0,0,1,31.12,42.29c.16,6.16.2,12.33,0,18.49-.09,2.84.85,4.05,3.62,4.82,71.74,20,112,69.26,129.14,139.74,4.5,18.53,5.93,37.47,5.94,56.52,0,48,.08,96-.1,144,0,5,1.26,8.6,4.93,12.19q27,26.39,53.36,53.38a12,12,0,0,1,3,7.27c.37,8.63.14,17.29.14,26.31H0c0-9.9-.11-19.83.13-29.74,0-1.31,1.76-2.69,2.9-3.84,17.88-17.93,35.7-35.93,53.79-53.66,3.53-3.46,4.76-7,4.76-11.79-.1-51.15-.37-102.31.19-153.46.45-41.29,10.73-80.07,33.6-114.88,23.86-36.31,57-60.13,98.95-71.35,4.73-1.26,5.91-3.18,5.73-7.74-.29-7.14-.56-14.42.49-21.44,3-20,16.51-34,36.2-38.56A13.13,13.13,0,0,0,239,0Z"/>
        <Path fill = "#6cc" class="cls-2" d="M185.24,538.7H307.63c-.64,20.59-8.88,37-25.11,49.19a61,61,0,0,1-67.69,3.56C195.93,580.24,182.71,556.85,185.24,538.7Z"/>
        </G>
        </G>
    
    </Svg>)
}

